<div class="d-flex align-items-center">
  <sb-local-date-range-input class="mr-3" [from]="from" [till]="till"
                             (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
  <ng-container *ngIf="showPlayerCull">
    <sb-comp-dropdown-select
      *ngPermissions="permissionService.Permission.cull_list"
      [showSubmit]="true"
      [inputData]="culls" [dropDownDatatype]="'PLAYER_CULLS'"
      (selectedDataEmitter)="update($event, 'PLAYER_CULLS')" [showColumnIcon]="false"
      [msOptions]="msCullOptions" (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
      [selectedInputData]="filteredPlayerCulls ? filteredPlayerCulls : []">
    </sb-comp-dropdown-select>
  </ng-container>
  <!-- Content for more filter options -->
  <ng-content>

  </ng-content>
  <ul class="nav nav-pills border-dashed-left pl-3 d-flex align-items-center" *ngIf="!hideInterval">
    <li class="nav-item px-1" *ngFor="let i of intervalSettings">
      <a class="nav-link" [class.active]="i?.interval === interval"
         [class.disabled]="i?.interval * 2 > util.parseDurationToSeconds(timespan)" (click)="setInterval(i?.interval)">
        <span class="nav-text">
                  {{i?.name}}
        </span>
      </a>
    </li>
  </ul>
</div>
